import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from "@ng-select/ng-select";
import { AiFlashcards } from './aiFlashcards';
import { AiFlashcardsRoutingModule } from "./aiFlashcards-routing.module";
import { TableModule } from "../generic/table/table.module";
import { AiService } from "../../../service/AiService";
import { CourseService } from "../../../service/CourseService";

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    NgSelectModule,
    TableModule,
    AiFlashcardsRoutingModule
  ],
  providers: [AiService, CourseService],
  exports: [AiFlashcards],
  declarations: [AiFlashcards]
})
export class AiFlashcardsModule {}
